import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  qaData: [],
  applicationSummary: {},
  useCases: [],
  testFramework: 'Pytest',
  scriptType: 'API',
  generatedTests: [],
  summary: null,
  results: [],
  loading: false,
  error: null,
};

const testEvaluationSlice = createSlice({
  name: 'testEvaluation',
  initialState,
  reducers: {
    setQaData: (state, action) => {
      state.qaData = action.payload;
    },
    setApplicationSummary: (state, action) => {
      state.applicationSummary = action.payload;
    },
    setUseCases: (state, action) => {
      state.useCases = action.payload;
    },
    setTestFramework: (state, action) => {
      state.testFramework = action.payload;
    },
    setScriptType: (state, action) => {
      state.scriptType = action.payload;
    },
    setGeneratedTests: (state, action) => {
      state.generatedTests = action.payload;
    },
    setSummary: (state, action) => {
      state.summary = action.payload;
    },
    setResults: (state, action) => {
      state.results = action.payload;
    },
    setTestEvaluationData: (state, action) => {
      const payload = action.payload;
      // Map 'dataset' from API to 'qaData' in Redux state
      if (payload.dataset && !payload.qaData) {
        payload.qaData = payload.dataset;
      }
      // Map 'framework' from API to 'testFramework' in Redux state
      if (payload.framework && !payload.testFramework) {
        payload.testFramework = payload.framework;
      }
      // Keep default values if fields are empty
      if (!payload.testFramework && !state.testFramework) {
        payload.testFramework = 'Pytest';
      }
      if (!payload.scriptType && !state.scriptType) {
        payload.scriptType = 'API';
      }
      return { ...state, ...payload, loading: false, error: null };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetTestEvaluation: () => initialState,
  },
});

export const {
  setQaData,
  setApplicationSummary,
  setUseCases,
  setTestFramework,
  setScriptType,
  setGeneratedTests,
  setSummary,
  setResults,
  setTestEvaluationData,
  setLoading,
  setError,
  resetTestEvaluation,
} = testEvaluationSlice.actions;

export default testEvaluationSlice.reducer;
